import { render, staticRenderFns } from "./OrganizationResources.vue?vue&type=template&id=5452bd98&scoped=true&lang=pug"
import script from "./OrganizationResources.vue?vue&type=script&lang=js"
export * from "./OrganizationResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452bd98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5452bd98')) {
      api.createRecord('5452bd98', component.options)
    } else {
      api.reload('5452bd98', component.options)
    }
    module.hot.accept("./OrganizationResources.vue?vue&type=template&id=5452bd98&scoped=true&lang=pug", function () {
      api.rerender('5452bd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/OrganizationResources.vue"
export default component.exports